import React from 'react'
import Head from '../components/Head'
import Header from '../components/Header'
import Intro from '../components/IntroGames'
import BiColumn__games from '../components/biColumn__games'
import Footer from '../components/footer'
import Button from '../components/Button'

export default class extends React.Component {
  joinAsPlayer = () => {
    const url = `https://app.playvs.com/sign-up/player`
    window.open(url, '_blank')
  }

  joinAsCoach = () => {
    const url = `https://app.playvs.com/sign-up/coach`
    window.open(url, '_blank')
  }
  render() {
    return (
      <React.Fragment>
        <Head title="PlayVS | Game Library" description="PlayVS is the official high school esports league, sanctioned by the NFHS. Play with your friends, compete for your school, and win the state championship." keywords="high school esports" />

        <Header />

        <Intro />

        <BiColumn__games />
        
        <section className="section section--blueGradient">
          <div className="container">
            <div className="section__head">
              <h2>Play. Compete. Win.</h2>
              <p>
                Build your team and start competing for the championship.
              </p>
            </div>
            <div className="section__CTA">
              <Button
                type="button"
                className="btn btn__reverse"
                text="Request to coach"
                onClick={this.joinAsCoach}
              />
              <Button
                type="button"
                className="btn btn__primary"
                text="Sign up to play"
                onClick={this.joinAsPlayer}
              />
            </div>
          </div>
        </section>

        <Footer />
        
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/ui/pages/games.js